import { TypesStatusListFilter } from "./data-products";

export interface ChapelTypes {
  id: string
  chapelName: string;
  description: string;
  status: string;
  accommodationDateRange?: string;
  createAt?: Date;
}

export interface AllCategoriesTypes {
  id: string
  categoryName: string;
  status: string;
}

export interface FBTabsType {
  id: number;
  labelName: string;
}

export const allFBTabs: FBTabsType[] = [
  {
    id: 1,
    labelName: 'Products'
  },
  // {
  //   id: 2,
  //   labelName: 'Categories'
  // },
  {
    id: 3,
    labelName: 'Packages'
  },
  {
    id: 4,
    labelName: 'Setup'
  },
  // {
  //   id: 5,
  //   labelName: 'Add-ons'
  // },
  // {
  //   id: 6,
  //   labelName: 'Sizes'
  // },
]


export const statusLabel: TypesStatusListFilter[] = [
  {
    id: 1,
    label: 'All'
  },
  {
    id: 2,
    label: 'Pending'
  },
  {
    id: 3,
    label: 'Processing'
  },
  {
    id: 4,
    label: 'For Pick-Up'
  },
  {
    id: 5,
    label: 'Cancelled'
  },
]

export const chapelStatus: TypesStatusListFilter[] = [
  {
    id: 1,
    label: 'Active'
  },
  {
    id: 2,
    label: 'Inactive'
  },
  // {
  //   id: 3,
  //   label: 'Under Maintenance'
  // },
  // {
  //   id: 4,
  //   label: 'Closed'
  // },
]

export const billingReportTypes = [
  {
    value: "summary" as const,
    title: "Summary",
    description: "Export summarized billing information.",
  },
  {
    value: "detailed" as const,
    title: "Detailed",
    description: "Export complete billing information.",
  },
];

export const packageDetailsTheadData = [
    { name: 'Name', id: 1},
    { name: 'Temperature', id: 2},
    { name: 'Category', id: 3},
    { name: 'Size', id: 4},
    { name: 'Price', id: 5},
    { name: 'Addons', id: 6},
]

export const clientPackageDetailsTheadData = [
    { name: 'Name', id: 1},
    { name: 'Temperature', id: 2},
    { name: 'Category', id: 3},
    { name: 'Active', id: 4},
    { name: 'Available', id: 5},
    { name: 'Size', id: 6},
    { name: 'Price', id: 7},
    { name: 'Addons', id: 8},
]

export const clientSpecialPackageDetailTheadData = [
    { name: 'Name', id: 1},
    { name: 'Temperature', id: 2},
    { name: 'Category', id: 3},
    // { name: 'Active', id: 4},
    { name: 'Available', id: 5},
    { name: 'Size', id: 6},
    // { name: 'Price', id: 7},
    { name: 'Addons', id: 8},
]

export const clientSpecialPackageAddTheadData = [
    { name: 'Name', id: 1},
    // { name: 'Category', id: 2},
    { name: 'Temperature', id: 3},
    { name: 'Size', id: 6},
    { name: 'Price', id: 7},
    { name: 'Addons', id: 8},
]

export const staffTheadData = [
    { name: 'Name', id: 1},
    // { name: 'Category', id: 2},
    { name: 'Email', id: 3},
    { name: 'Status', id: 6},
    { name: 'Role', id: 7},
    { name: 'Action', id: 8},
]

export interface SetUpData {
  name: string;
  id: number;
}

export const productTheadData: SetUpData[] = [
    { name: 'Name', id: 1},
    { name: 'Category', id: 3},
    { name: 'Available', id: 4},
    { name: 'Size', id: 5},
    { name: 'Temperature', id: 2},
    { name: 'Price', id: 6},
    { name: 'Addons', id: 7},
    { name: 'Action', id: 8},
]

export const setUpCategory: SetUpData[] = [
    { name: 'Name', id: 1},
    // { name: 'Category', id: 2},
    { name: 'Status', id: 3},
    { name: 'Action', id: 8},
]


export const setUpTemperature: SetUpData[] = [
    { name: 'Name', id: 1},
    // { name: 'Category', id: 2},
    { name: 'Status', id: 3},
    { name: 'Action', id: 8},
]

export const setUpAddons: SetUpData[] = [
    { name: 'Name', id: 1},
    // { name: 'Category', id: 2},
    { name: 'Status', id: 3},
    { name: 'Price', id: 4},
    { name: 'Action', id: 8},
]

export const setUpSize: SetUpData[] = [
    { name: 'Name', id: 1},
    // { name: 'Category', id: 2},
    { name: 'Status', id: 3},
    { name: 'Action', id: 8},
]

export const updatePackageTHeadData: SetUpData[] = [
    { name: 'Name', id: 1},
    { name: 'Temperature', id: 2},
    { name: 'Category', id: 3},
    { name: 'Size', id: 4},
    { name: 'Price', id: 5},
    { name: 'Addons', id: 6},
    { name: 'Action', id: 7},
]